// noinspection JSVoidFunctionReturnValueUsed

import {FrontStorageService} from './storage.service';
import {Inject, Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {HOST_THIRD_PARTY_ID} from '../../tokens/thirdParty.token';

@Injectable({
    providedIn: 'root'
})
export class FrontLocalStorageService extends FrontStorageService {
    constructor(@Inject(HOST_THIRD_PARTY_ID) private readonly hostThirdPartyId: string) {
        super(hostThirdPartyId);
    }

    get<T>(key: string): Observable<T> {
        const item: string = localStorage.getItem(this.prepareKey(key));
        if (item == null) {
            return of(undefined);
        }

        return of(JSON.parse(item) as T);
    }

    remove(key: string): Observable<void> {
        return of(localStorage.removeItem(this.prepareKey(key)));
    }

    set<T>(key: string, value: T): Observable<T> {
        const item: string = JSON.stringify(value);
        localStorage.setItem(this.prepareKey(key), item);
        return of(value);
    }
}
